import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import notify from 'devextreme/ui/notify';
import ValidationEngine from 'devextreme/ui/validation_engine';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ScreenService} from '../../../../../shared/services/general';

@Component({
  selector: 'app-patient-responsible-party-form-dialog',
  templateUrl: './patient-responsible-party-form-dialog.component.html',
  styleUrls: ['./patient-responsible-party-form-dialog.component.scss']
})
export class PatientResponsiblePartyFormDialogComponent implements OnInit, OnDestroy {
  public responsiblePartiesForm: FormGroup = this.fb.group({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    country: new FormControl(),
    state: new FormControl(),
    city: new FormControl(),
    zipCode: new FormControl(),
    zipCodeExtra: new FormControl('',  [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    mobile: new FormControl(),
    fax: new FormControl()
  });
  @Input() public popupVisible: boolean = false;
  @Input() public id = -1;
  @Output() public closed = new EventEmitter();
  public phoneMaskRule = {X: /[0-9]/};
  public isPhoneOrTablet: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private fb: FormBuilder, private screen: ScreenService) {
  }

  public ngOnInit(): void {
    this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    });
  }

  public convertToFormControl(absCtrl: AbstractControl | null): FormControl {
    return absCtrl as FormControl;
  }

  public clear() {
    this.responsiblePartiesForm.get('firstName')?.setValue('');
    this.responsiblePartiesForm.get('lastName')?.setValue('');
    this.responsiblePartiesForm.get('address')?.setValue('');
    this.responsiblePartiesForm.get('country')?.setValue(null);
    this.responsiblePartiesForm.get('state')?.setValue(null);
    this.responsiblePartiesForm.get('city')?.setValue(null);
    this.responsiblePartiesForm.get('zipCode')?.setValue('');
    this.responsiblePartiesForm.get('zipCodeExtra')?.setValue('');
    this.responsiblePartiesForm.get('phone')?.setValue('');
    this.responsiblePartiesForm.get('mobile')?.setValue('');
    this.responsiblePartiesForm.get('fax')?.setValue('');
  }

  public close() {
    this.popupVisible = false;
    this.responsiblePartiesForm.reset();
    this.closed.emit();
    ValidationEngine.resetGroup('responsibleParty');
    ValidationEngine.resetGroup('address');
  }


  public save() {
    const responsibleParty = ValidationEngine.validateGroup('responsibleParty');
    const address = ValidationEngine.validateGroup('address');
    if (responsibleParty.isValid && address.isValid) {
      if (this.responsiblePartiesForm.get('zipCode')?.value) {
        const rp = this.responsiblePartiesForm.value;
        rp.firstName = rp.firstName.toUpperCase();
        rp.lastName = rp.lastName.toUpperCase();
        this.popupVisible = false;
        this.closed.emit(rp);
        this.clear();
        ValidationEngine.resetGroup('responsibleParty');
        ValidationEngine.resetGroup('address');
      } else {
        notify('Missing address information', 'error');
      }
    }
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
